import { render, staticRenderFns } from "./InsuredData.vue?vue&type=template&id=560ad2e2"
import script from "./InsuredData.vue?vue&type=script&lang=js"
export * from "./InsuredData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports